import { render, staticRenderFns } from "./IncludesTabs.vue?vue&type=template&id=29216325&"
import script from "./IncludesTabs.vue?vue&type=script&lang=js&"
export * from "./IncludesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports